export enum CacheOperation {
  PREPEND_CACHE_ITEM_IN_FIRST_PAGE,
  APPEND_CACHE_ITEM_IN_LAST_PAGE,
  DELETE_CACHE_ITEM,
  UPDATE_CACHE_ITEM,
  REMOVE_CACHE,
  CLEAR_CACHE,
}
